import { createAction, props } from '@ngrx/store';

import { CustomerDetails } from '../../../objects/checkout-request';
import { Order } from '../../../objects/order';
import { Transaction } from '../../../objects/transaction';

export const beginCheckout = createAction(
  '[Order] Begin Checkout',
);

export const checkout = createAction(
  '[Order] Checkout',
  props<{token: string; customerDetails: CustomerDetails; order: Order; marketingCommunications: boolean }>(),
);

export const checkoutStatusUpdate = createAction(
  '[Order] Checkout Transaction Status Update',
  props<{transaction: Transaction}>(),
);

export const checkoutSuccess = createAction(
  '[Order] Checkout Success',
  props<{transaction: Transaction; completedOrder: Order}>(),
);

export const checkoutFailure = createAction(
  '[Order] Checkout Failure',
  props<{error: Error}>(),
);

export const transactionPolling = createAction(
  '[Order] Transaction Polling',
  props<{order: Order; transaction: Transaction; timeoutInMs: number}>(),
);
